<div class="form-row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h6 class="card-title">
          <div class="form-row">
            <div class="col-12">Buscar Rnc / cédula</div>
          </div>
        </h6>
      </div>
      <div class="card-body">
        <!-- <div class="form-row">
          <div class="col-lg-8">
            <div class="form-check">
              <input
                class="form-check-input"
                [(ngModel)]="tipoEntidad"
                type="radio"
                required
                name="personaFisica"
                id="gridRadios1"
                value="F"
                (change)="limpiarDatos()"
                checked
              />
              <label
                for="gridRadios1"
                class="form-check-label"
                for="gridRadios1"
              >
                Persona Física (Profesional Independiente)
              </label>
            </div>
            <div class="form-check">
              <input
                class="form-check-input"
                [(ngModel)]="tipoEntidad"
                type="radio"
                required
                name="personaJuridica"
                id="gridRadios2"
                (change)="limpiarDatos()"
                value="J"
              />
              <label
                for="gridRadios2"
                class="form-check-label"
                for="gridRadios2"
              >
                Persona Jurídica (MIPYME)
              </label>
            </div>
          </div>
        </div> -->

        <!-- <div class="form-group form-row">
          <div class="input-group col-12 col-lg-6 mb-3">
            <ng-container *ngIf="tipoEntidad == 'J'; else PF">
              <input
                #inputBusqueda
                type="text"
                name="numerodoc"
                style="height: 42px"
                mask="000-00000-0"
                placeholder="000-00000-0"
                [(ngModel)]="numerodoc"
                class="form-control mt-2"
                (keyup.enter)="buscar()"
              />
            </ng-container>
            <ng-template #PF>
              <input
                #inputBusqueda
                type="text"
                name="numerodoc"
                style="height: 42px"
                mask="000-0000000-0"
                placeholder="000-0000000-0"
                [(ngModel)]="numerodoc"
                class="form-control mt-2"
                (keyup.enter)="buscar()"
              />
            </ng-template>
            <div class="input-group-append ml-2">
              <button type="button" class="btn btn-primary" (click)="buscar()">
                Buscar
              </button>
            </div>
          </div>
        </div> -->
{{service.model.Estatus}}
        <div class="form-group form-row">
          <div class="input-group col-12 col-lg-6 mb-3">
            <input
              #inputBusqueda
              type="text"
              name="numerodoc"
              style="height: 42px"
              placeholder="Rnc/Cédula (Sin guiones)"
              [(ngModel)]="numerodoc"
              class="form-control mt-2"
              (keyup.enter)="buscar()"
            />
            <div class="input-group-append ml-2">
              <button type="button" class="btn btn-primary" (click)="buscar()">
                Buscar
              </button>
            </div>
          </div>
        </div>

        <ng-container *ngIf="service.model.Rnc && service.model.Rnc.length > 0">
          <div class="form-row mb-2">
            <div class="col-12 col-lg-4">
              <strong>Rnc / cédula:</strong>
            </div>
            <div class="col-12 col-lg-8">
              {{ service.model.Rnc | identification }}
            </div>
          </div>

          <div class="form-row pb-2 mb-2 border-bottom">
            <div class="col-12 col-lg-4">
              <strong>Razón social:</strong>
            </div>
            <div class="col-12 col-lg-8">
              {{ service.model.RazonSocial }}
            </div>
          </div>

          <ng-container *ngIf="!service.model.CodigoRegistro; else PF">
            <ng-container *ngIf="service.model.Rnc.length == 11">
              <div class="form-row mb-2">
                <div class="col-12 col-lg-4">
                  <strong>Es empleado de MOPC:</strong>
                </div>
                <div class="col-12 col-lg-8">
                  <span *ngIf="service.model.ActivarEmpleadoMOPC">Sí</span>
                  <span *ngIf="!service.model.ActivarEmpleadoMOPC">No</span>
                </div>
              </div>

              <div class="form-row mb-2">
                <div class="col-12 col-lg-4">
                  <strong> Esta registrado en el CODIA: <br /> </strong>
                  <span style="font-size: smaller">
                    Ingenieros Civiles o Arquitectos
                  </span>
                </div>
                <div class="col-12 col-lg-8 mt-2">
                  <span *ngIf="service.model.ActivarCodia">Sí</span>
                  <span *ngIf="!service.model.ActivarCodia">No</span>
                </div>
              </div>
            </ng-container>

            <div class="form-row mb-2">
              <div class="col-12 col-lg-4">
                <strong>Esta registrado en DGII:</strong>
              </div>
              <div class="col-12 col-lg-8">
                <span *ngIf="service.model.ActivarDgii">Sí</span>
                <span *ngIf="!service.model.ActivarDgii">No</span>
              </div>
            </div>
            <div class="form-row mb-2">
              <div class="col-12 col-lg-4">
                <strong>Esta certificado como MIPYME:</strong>
              </div>
              <div class="col-12 col-lg-8">
                <span *ngIf="service.model.ActivarMiPyme">Sí</span>
                <span *ngIf="!service.model.ActivarMiPyme">No</span>
              </div>
            </div>

            <div class="form-row mb-2">
              <div class="col-12 col-lg-4">
                <strong>{{service.model.Estatus}}</strong>
              </div>
              <!-- <div class="col-12 col-lg-8">
                <span *ngIf="service.model.ActivarMiPyme">Sí</span>
                <span *ngIf="!service.model.ActivarMiPyme">No</span>
              </div> -->
            </div>
          </ng-container>
          <ng-template #PF>
            <div class="form-row pb-2 mb-2">
              <div class="col-12 col-lg-4">
                <strong>Número de inscripcion:</strong>
              </div>
              <div class="col-12 col-lg-8">
                {{ service.model.CodigoRegistro }}
              </div>
            </div>

            <div class="form-row pb-2 mb-2">
              <div class="col-12 col-lg-4">
                <strong>Día de entrega:</strong>
              </div>
              <div class="col-12 col-lg-8">
                {{ service.model.Dia }}
              </div>
            </div>

            <div class="form-row pb-2 mb-2">
              <div class="col-12 col-lg-4">
                <strong>Hora de entrega:</strong>
              </div>
              <div class="col-12 col-lg-8">
                {{ service.model.Hora }}
              </div>
            </div>
          </ng-template>

          <div class="form-row">
            <div class="col-12 col-lg-3">
              <button
                class="btn btn-secondary btn-md btn-block"
                (click)="limpiarDatos()"
              >
                Limpiar datos
              </button>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
